<template>
  <mf-loading-dialog :loading="loadingPage">
    <base-page-layout
      :hide-header="hideHeader"
      :title="pageTitle"
      class="pa-3 pb-4"
      :flow-id="flowId"
      :show-tour="!!flowId"
      :loading-tutorial="loadingTutorial"
    >
      <template v-if="['ACTIVE', 'FINISHED'].includes(campaign.status)" v-slot:title-complement>
        <div class="pl-3">
          <mf-button label="Ver resultados da campanha" outlined text-transform="none" icon="monitoring" icon-position="left" @click="emitResultsFunction" />
        </div>
      </template>
      <div class="maria-edit-container">
        <div v-show="!hideHeader" class="maria-header">
          <mf-button class="maria-back-button" icon="arrow_back" label="Voltar" color="marca-0-l40" text @click="redirectBackButton" />
          <div class="maria-steppers">
            <mf-stepper :steppers="steppers" :step="step" />
          </div>
        </div>
        <div class="maria-body">
          <offer-schedule-selection
            v-if="showStepComponent('offer-schedule-selection')"
            ref="step-one-offers-selection"
            :initially-products="initiallyProducts"
          />
          <product-details
            v-else-if="showStepComponent('product-details')"
            ref="step-two-product-details"
            :disabled="isMariaCampaignFinished"
            :initially-products="initiallyProducts"
          />
          <client-target-distribution v-else-if="showStepComponent('client-target-distribution')" ref="step-three-client-target-distribution" />
          <channels-configuration
            v-else-if="showStepComponent('channels-configuration')"
            ref="step-four-channels-configuration"
            @channel-selected="handleChannelSelected"
          />
          <dispatches-configuration v-else-if="showStepComponent('dispatches-configuration')" ref="step-five-dispatch-configuration" />
        </div>
        <div v-if="!isShowChannelForm()" class="maria-actions">
          <mf-action-buttons
            class="mt-5"
            :primary-button="primaryButton"
            :back-button="backButton"
            :secondary-button="secondaryButton"
            :cancel-button="cancelButton"
          />
        </div>
      </div>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { mariaCampaign } from '../../mixins/maria-campaign'
import BasePageLayout from '@/components/BasePageLayout.vue'
import OfferScheduleSelection from '../components/OfferScheduleSelection/Index.vue'
import DispatchesConfiguration from '../components/DispatchesConfiguration/Index.vue'
import ProductDetails from '../components/ProductDetails/Index.vue'
import ClientTargetDistribution from '../components/ClientTargetDistribution/Index.vue'
import ChannelsConfiguration from '../components/ChannelsConfiguration/Index.vue'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'MariaEdit',
  components: {
    BasePageLayout,
    ProductDetails,
    OfferScheduleSelection,
    DispatchesConfiguration,
    ClientTargetDistribution,
    ChannelsConfiguration,
  },
  mixins: [mariaCampaign],
  props: {},
  data: () => ({
    isDraft: true,
    loadingPage: false,
    steppers: [
      {
        step: 1,
        complete: false,
        stepName: 'Ofertas',
        pathName: '',
      },
      {
        step: 2,
        complete: false,
        stepName: 'Detalhes dos produtos',
        pathName: '',
      },
      {
        step: 3,
        complete: false,
        stepName: 'Público alvo',
        pathName: '',
      },
      {
        step: 4,
        complete: false,
        stepName: 'Agendamento',
        pathName: '',
      },
      {
        step: 5,
        complete: false,
        stepName: 'Limites de disparo',
        pathName: '',
      },
    ],
    channelSelected: '',
    initiallyProducts: [],
    loadingTutorial: false,
  }),
  computed: {
    flowId() {
      const FLOW_IDS = {
        1: 'd68f7409-9176-4e77-a982-65509c0c1ac0',
        2: 'c35af8c0-f488-428e-9f11-e3558f902926',
        4: 'da0cc721-e2b1-4525-9900-b9c98a94bd5c',
      }
      return FLOW_IDS[this.step] || ''
    },
    newCampaign() {
      return this.$router.currentRoute.fullPath.includes('nova')
    },
    pageTitle() {
      return this.newCampaign ? 'Nova campanha da mar.ia' : 'Editar campanha da mar.ia'
    },
    primaryButton() {
      return [1, 2, 3, 4].includes(this.step)
        ? {
            text: 'Próximo',
            icon: 'arrow_forward',
            color: 'marca-0-l40',
            iconPosition: 'right',
            action: this.handleNextStep,
            isVisible: true,
            isDisabled: false,
            isLoading: this.loadingSaveNext || this.loadingAction,
          }
        : {
            text: 'Concluir campanha',
            action: this.handleFinish,
            isVisible: true,
            isDisabled: this.isMariaCampaignFinished,
            isLoading: this.loadingSaveDraft || this.loadingAction,
          }
    },
    secondaryButton() {
      if (this.isMariaCampaignFinished) return {}
      return this.isDraft
        ? {
            text: 'Salvar rascunho',
            action: () => this.handleNextStep(true),
            isVisible: !this.isCampaignActivated,
            isDisabled: false,
            isLoading: this.loadingSaveDraft || this.loadingAction,
          }
        : {
            text: 'Salvar e sair',
            action: () => this.handleNextStep(true),
            isVisible: !this.isCampaignActivated,
            isDisabled: false,
            isLoading: this.loadingSaveDraft || this.loadingAction,
          }
    },
    backButton() {
      return {
        text: 'Voltar',
        action: this.redirectBackButton,
        isVisible: true,
        isDisabled: false,
      }
    },
    cancelButton() {
      return {
        text: this.isMariaCampaignFinished ? 'Fechar' : 'Cancelar',
        action: this.redirectToIndex,
        isVisible: true,
        isDisabled: false,
      }
    },
    hideHeader() {
      return !!this.channelSelected
    },
  },
  async mounted() {
    this.loadingPage = true
    if (this.itsGetCampaignFromApi) {
      await this.getCampaign()
    } else {
      this.$store.commit('RESET_MARIA_CAMPAIGN_MODULE')
    }
    this.loadingPage = false
    this.updateSteppersCompletion()
    this.initiallyProducts = cloneDeep(this.campaign.offer_sales)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.forcePush && !this.isMariaCampaignFinished) {
      this.$confirm({
        title: 'Tem certeza?',
        message:
          'Sua campanha ainda não foi salva e todas as suas alterações recentes serão perdidas ao sair dessa página. Para continuar editando clique em <strong>continuar editando</strong>, para sair sem salvar clique em <strong>descartar alterações</strong>.',
        confirmText: 'Continuar editando',
        cancelText: 'Descartar alterações',
      })
        .then(() => {
          next(false)
        })
        .catch(() => {
          this.$store.commit('RESET_MARIA_CAMPAIGN_MODULE')
          next()
        })
    } else {
      next()
    }
  },
  methods: {
    getOffertype(campaign) {
      const { combo_offer_sales, offer_sales, percentage_offer_sales, takepay_offer_sales } = campaign
      if (offer_sales.length) return 'general'
      if (combo_offer_sales.length) return 'combo'
      if (percentage_offer_sales.length) return 'percentage'
      if (takepay_offer_sales.length) return 'takepay'
    },
    changeStepValue(value) {
      this.step = value
      this.updateSteppersCompletion()
    },
    async getCampaign() {
      await this.getOmniCampaign({
        id: this.$route.params.id,
      })
    },
    isShowChannelForm() {
      return this.$refs['step-four-channels-configuration']?.showChannelForm
    },
    updateSteppersCompletion() {
      this.steppers = this.steppers.map((stepper) => ({
        ...stepper,
        complete: stepper.step < this.step,
      }))
    },
    handleNextStep(isDraft = false) {
      this.validateCurrentStep(isDraft)
    },
    validateCurrentStep(isDraft = false) {
      if (this.isMariaCampaignFinished) {
        if (this.step < 5) this.changeStepValue(this.step + 1)
        return
      }

      const stepValidationMap = {
        1: { ref: 'step-one-offers-selection', method: 'validateStepOneFormData' },
        2: { ref: 'step-two-product-details', method: 'validateStepTwoFormData' },
        3: { ref: 'step-three-client-target-distribution', method: 'validateStepThreeFormData' },
        4: { ref: 'step-four-channels-configuration', method: 'validateStepFourFormData' },
        5: { ref: 'step-five-dispatch-configuration', method: 'validateStepFiveFormData' },
      }
      const current = stepValidationMap[this.step]
      if (!current) return
      const isValid = this.$refs[current.ref]?.[current.method]?.()
      if (isValid) {
        if (isDraft) {
          this.upsertDraftMariaCampaign(isDraft, this.step)
        } else {
          if (this.step < 5) {
            this.changeStepValue(this.step + 1)
          } else {
            this.upsertDraftMariaCampaign()
          }
        }
      }
    },
    handleFinish() {
      this.validateCurrentStep()
    },
    showStepComponent(key) {
      const componentsKeys = ['offer-schedule-selection', 'product-details', 'client-target-distribution', 'channels-configuration', 'dispatches-configuration']
      return componentsKeys.indexOf(key) + 1 === this.step
    },
    redirectToIndex() {
      this.$router.push({ name: 'maria-campaign' })
    },
    redirectBackButton() {
      if (this.step === 1) {
        this.redirectToIndex()
      } else {
        this.step -= 1
        this.updateSteppersCompletion()
      }
    },
    handleChannelSelected(channelName) {
      this.channelSelected = channelName
    },
    emitResultsFunction() {
      const route = this.$router.resolve({ name: 'results-maria-campaign', params: { id: this.campaign._id } })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.maria-edit-container {
  .maria-header {
    margin-bottom: 20px;

    .maria-steppers {
      max-width: 80%;
      margin: 0 auto;
    }
    .maria-back-button {
      position: absolute;
      margin-top: 20px;
    }
  }
}
</style>
